<template>
    <action>
        <template v-slot:header>
            Mail-Sammel Adresse
        </template>

        <input-text v-model="mail">
            Sammeladresse
            <template v-slot:helper>
                OfficeEfficient benachrichtigt in der Regel alle Admin-User über einen Fehler.
                Dieses Verhalten kann mit dem Setzen einer Sammeladresse überschrieben werden.
            </template>
        </input-text>

        <p v-show="!hasCumulateMail" class="mt-4n">
            Aktuell ist keine Sammeladresse hinterlegt. Alle Administratoren werden benachrichtigt.
        </p>

        <template v-slot:action>
            <button-primary @click="submit">
                <i class="fa fa-save"></i> Speichern
            </button-primary>
        </template>
    </action>
</template>

<script>
import ButtonPrimary from "../UI/ButtonPrimary";
import Action from "../UI/Action";
import InputText from "../UI/InputText.vue";

export default {
    name: "MailCumulate",

    components: {InputText, Action, ButtonPrimary},

    inject: ['group'],

    data: () => ({
        mail: '',
    }),

    created() {
        this.mail = this.group.admin_cumulate_mail ?? '';
    },

    computed: {
        hasCumulateMail() {
            return this.group.admin_cumulate_mail !== null;
        },
    },

    methods: {
        submit() {
            this.loading = true;
            window.axios.post('/admin/group', {
                admin_cumulate_mail: this.mail,
            }).then((response) => {
                location.reload();
            }).catch((error) => {
                location.reload();
            })
        },
    }
}
</script>

<style scoped>

</style>
